/** The entrance register needs a full name and a usable phone number. */
export function validateGuestRegisterContact(input: { name: string; email: string; phone: string }) {
  const name = input.name.trim();
  const email = input.email.trim();
  const phone = input.phone.trim();
  const nameError = name.length < 2 ? "Enter your full name." : "";
  const emailError = email && !/^\S+@\S+\.\S+$/.test(email) ? "Enter a valid email address." : "";
  const digits = phone.replace(/\D/g, "");
  const phoneError = phone && (digits.length < 7 || digits.length > 15 || !/^[+\d\s().-]+$/.test(phone)) ? "Enter a valid phone number." : "";
  const contactError = !phone ? "Please provide your phone number." : "";
  return { nameError, emailError, phoneError, contactError, valid: !nameError && !emailError && !phoneError && !contactError };
}

/** Required mailing fields; apartment/suite remains optional. */
export function validateGuestRegisterAddress(address: { street: string; city: string; state: string; zip: string }) {
  return missingGuestAddressFields(address).length === 0;
}

export function missingGuestAddressFields(address: { street: string; city: string; state: string; zip: string }) {
  return (["street", "city", "state", "zip"] as const).filter(key => !address[key].trim()).map(key => ({ street: "Street Address", city: "City", state: "State", zip: "ZIP Code" })[key]);
}
